import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PixIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pix"}/>
}
